/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : AppProposalEvaluationConverter.ts
*******************************************/

import { isProposeAppDownload, isProposeOpenInApp, isProposeOpenInAppWithScheme, ProposeAppDownload, ProposeOpenInApp, ProposeOpenInAppWithScheme } from "../../EvaluatedAction.js";
import { CTA_NAME, CTA_OUTCOME, CTAStatsDetails } from "../../../stats/CTATypes.js";
import { EvaluationConverter } from "../EvaluationConverter.js";
import { NotificationDeviceType } from "../../../api/types/SubscriptionTypes.js";

export class AppProposalEvaluationConverter implements EvaluationConverter {
    public check = (act: any) => {
        return isProposeAppDownload(act) || isProposeOpenInApp(act) || isProposeOpenInAppWithScheme(act);
    };
    
    public convert(action: ProposeAppDownload|ProposeOpenInApp|ProposeOpenInAppWithScheme): CTAStatsDetails {
        
        
        if (action.data == NotificationDeviceType.IOS) {
            return {
                outcome: CTA_OUTCOME.SHOWN,
                action: CTA_NAME.APP_OPEN_INST,
                device_type: NotificationDeviceType.IOS,
                source_element: "evaluation"
            };
        }
        else {
            let useName: CTA_NAME = CTA_NAME.APP_OPEN_INST;
            if (isProposeOpenInAppWithScheme(action)) {
                useName = CTA_NAME.APP_OPEN_INST;
            }
            else if (isProposeAppDownload(action)) {
                useName = CTA_NAME.APP_INST;
            }
            else {
                useName = CTA_NAME.APP_OPEN;
            }
            return {
                outcome: CTA_OUTCOME.SHOWN,
                action: useName,
                device_type: NotificationDeviceType.ANDROID,
                source_element: "evaluation"
            };
        }
        
    }
}